import { YesNoUnknown } from '@nkr/enums/yes-no-unknown';
import { IListItem } from '../list-item'

export interface IDonorProfileMedicalDetailsData {
    donorId: number,
    donorAlias: string,
    dateOfEvaluation: string,
    birthDate: string,
    birthYear: number,
    isDonorMedicallySound: boolean,
    medicalComments: string,
    bp24Hour: string,
    donorCtAbnormalities: string,
    bloodType: string,
    aboASubType: number,
    aboAbSubType: number,
    isAboConfirmed: boolean,
    whichKidney: string,
    numberOfVeins: number,
    numberOfArteries: number,
    numberOfUreters: number,
    heightCm: number,
    heightFeet: number,
    heightInches: number,
    heightInchesRemaining: number,
    weightKg: number,
    weightLbs: number,
    bloodPressure: number,
    sbp: number,
    dbp: number,
    kidneyHeight: number,
    kidneyLength: number,
    kidneyWidth: number,
    kidneyVolume: number,
    hasEarlyBifurcation: boolean,
    earlyBifurcationLength: number,
    gender: string,
    race: string,
    creatinineClearance: number,
    creatinineCollectionMethod: number,
    serumCreatinine: number,
    albuminExcretion: string,
    urineProtein: string,
    isAtRisk: number,
    ebv: string,
    hepBAntigen: string,
    hepBAntibody: string,
    cmv: string,
    antiHcv: string,
    rprVdrl: string,
    hiv: string,
    tbStatus: string,
    hasHistoryOfSmoking: boolean,
    hasNutcracker: YesNoUnknown,
    canOrderCryo: boolean,
    hasCtScanOnline: boolean,
    histogeneticsAbo: string
}

export interface IDonorProfileMedicalDetailsLookupData {
    bloodPressureList: IListItem[],
    raceList: IListItem[],
    genderList: IListItem[],
    collectionMethodList: IListItem[],
    whichKidneyList: { id: string, description: string }[]
}

export interface IDonorProfileMedicalDetailsPost {
    dateOfEvaluation: string,
    isDonorMedicallySound: boolean,
    medicalComments: string,
    bp24Hour: string,
    donorCtAbnormalities: string,
    bloodType: string,
    aboASubType: number,
    aboAbSubType: number,
    isAboConfirmed: boolean,
    whichKidney: string,
    numberOfVeins: number,
    numberOfArteries: number,
    numberOfUreters: number,
    heightCm: number,
    heightInches: number,
    weightKg: number,
    weightLbs: number,
    bloodPressure: number,
    sbp: number,
    dbp: number,
    kidneyHeight: number,
    kidneyLength: number,
    kidneyWidth: number,
    kidneyVolume: number,
    hasEarlyBifurcation: boolean,
    earlyBifurcationLength: number,
    gender: string,
    race: string,
    creatinineClearance: number,
    creatinineCollectionMethod: number,
    serumCreatinine: number,
    albuminExcretion: string,
    urineProtein: string,
    isAtRisk: number,
    ebv: string,
    hepBAntigen: string,
    hepBAntibody: string,
    cmv: string,
    antiHcv: string,
    rprVdrl: string,
    hiv: string,
    tbStatus: string,
    hasHistoryOfSmoking: boolean
}